import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as actions from "../../actions";
import * as Template from "../../templates";

import EditorField from "../../templates/modules/forms/Editor";
import { useNavigate, useParams } from "react-router-dom";

export default () => {

  const moduleName = "faqs";

  const appReducer = useSelector((state) => state.appReducer, shallowEqual);

  const dispatch = useDispatch();

  const params = useParams()

  const navigate = useNavigate()

  const [id, setId] = useState();

  const [name, setName] = useState(``);
  const [state, setState] = useState(``);
  const [description, setDescription] = useState(``);
  const [content, setContent] = useState(``);

  const [categoryId, setCategoryId] = useState(``);
  const [categories, setCategories] = useState(``);

  const [submitted, setSubmitted] = useState(false);

  const onChange = (value) => setCategoryId(value);
  const handleDescriptionChange = (value) => setDescription(value);

  const handleChangeState = (value) => setState(value);
  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.faqs_store != undefined && appReducer.faqs_store.error == false) ||
        (appReducer.faqs_update != undefined && appReducer.faqs_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.faqs_store,
    appReducer.faqs_update
  ])


  useEffect(() => {
    if (appReducer.faqs_edit != undefined && id != undefined) {
      let row = appReducer.faqs_edit.data;
      setName(row.name);
      setDescription(row.description);
      setContent(row.content);
      setState({
        value: row.state,
        label: row.state == `active` ? `فعال` : `غیرفعال`,
      });
      setCategoryId({
        value: row.faq_category.id,
        label: row.faq_category.name,
      });
    }
  }, [appReducer.faqs_edit]);

  useEffect(() => {
    if (appReducer.faq_categories_option_list != undefined) {
      setCategories(appReducer.faq_categories_option_list.data);
    }
  }, [appReducer.faq_categories_option_list]);

  useEffect(() => {
    dispatch(actions.list(`faq_categories/option`));
  }, []);


  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])


  return <Template.Form>
    <Template.Input required value={name} label="نام" name="name" type="text" />
    <Template.Textarea required value={content} label="شرح" name="content" type="text" />
    <div>
      <EditorField
        label="توضیحات"
        onEditorChange={handleDescriptionChange}
        value={description}
      />
      <input name="description" type="hidden" defaultValue={description} />
    </div>
    <Template.SingleSelect
      withLabel
      required
      placeholder="گروه"
      name="faq_category_id"
      value={categoryId}
      onChange={onChange}
      options={categories}
    />
    <Template.SingleSelect
      withLabel
      required
      placeholder="وضعیت"
      onChange={handleChangeState}
      name="state"
      value={state}
      options={[
        {
          value: "active",
          label: "فعال",
        },
        {
          value: "deactive",
          label: "غیرفعال",
        },
      ]}
    />

    <Template.Button
      label="ذخیره"

      onClick={handleClick}
    />
  </Template.Form>
};